import { Component, OnInit, ViewChild } from '@angular/core';
import { AcodisWorkflowOverviewComponent } from './acodis-workflow-overview/acodis-workflow-overview.component';
import { AcodisWorkflowDTO, ImportType } from 'src/app/base/models/models.swagger.generated';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AcodisWorkflowService } from './acodis-workflow.service';
import { ModalService } from 'src/app/base/shared/modal/modal.service';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AcodisWorkflowFormComponent } from './acodis-workflow-form/acodis-workflow-form.component';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { ToastService } from 'src/app/base/services/toast.service';
import { AcodisWorkflowFormType } from './acodis-workflow-form/acodis-workflow-form-type';
import { NavigationEnd, Router } from '@angular/router';
import { acodisWorkflowCreateRoute, acodisWorkflowRoute } from 'src/app/core/routing/route-names';
import { UrlHelper } from 'src/app/base/shared/url-helper';
import * as pages from '../../../core/routing/page-names';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { filter } from 'rxjs';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
    selector: 'app-acodis-workflow',
    templateUrl: './acodis-workflow.component.html',
    styleUrls: ['./acodis-workflow.component.scss'],
    imports: [AcodisWorkflowOverviewComponent, AcodisWorkflowFormComponent, TranslateModule, ReactiveFormsModule, TitleBarComponent]
})
export class AcodisWorkflowComponent extends GridBaseComponent<any> implements OnInit {

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }
  protected override getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  @ViewChild(AcodisWorkflowOverviewComponent) acodisWorkflowOverviewComponent: AcodisWorkflowOverviewComponent;
  @ViewChild(AcodisWorkflowFormComponent) acodisWorkflowFormComponent: AcodisWorkflowFormComponent;

  public workflow: AcodisWorkflowDTO = null;

  public acodisWorkflowForm: FormGroup<AcodisWorkflowFormType>;
  constructor(
    translateService: TranslateService,
    private acodisWorkflowService: AcodisWorkflowService,
    private fb: FormBuilder,
    private modalService: ModalService,
    private toastService: ToastService,
    private spinnerService: SpinnerService,
    private router: Router,
  ) {
    super(translateService, acodisWorkflowService);
  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.acodisWorkflowService, this.spinnerService)
    });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd && (event.url.includes(acodisWorkflowRoute) || event.url.includes(acodisWorkflowCreateRoute)))).subscribe(() => {
      this.urlChanged();
    });

    this.initForm();
  }

  public urlChanged(): void {
    var id = UrlHelper.getIdForSegment(pages.acodisWorkflowsPageName, this.router);
    if (this.router.url.startsWith(acodisWorkflowCreateRoute)) {
      this.workflow = new AcodisWorkflowDTO({
        id: 0,
        name: null,
        importType: null,
        userName: null,
        password: null,
        isInUse: false
      });
      this.loadDataToForm(this.workflow);
    }
    else if (id != null) {
      this.acodisWorkflowService.getAcodisWorkflow(+id).subscribe(data => {
        this.workflow = data;
        this.loadDataToForm(data);
      });
    } else {
      this.workflow = null;
      this.acodisWorkflowForm.reset();
      if (this.acodisWorkflowOverviewComponent.grid?.selectedRowIndex >= 0) {
        this.acodisWorkflowOverviewComponent.grid.selectRows([]);
      }
    }
  }

  public dataBound(): void {
    var id = UrlHelper.getIdForSegment(pages.acodisWorkflowsPageName, this.router);
    if (id != null) {
      this.acodisWorkflowOverviewComponent.grid.selectRow(this.acodisWorkflowOverviewComponent.grid.getRowIndexByPrimaryKey(id));
    }
    this.urlChanged();
  }

  public addWorkflow() {

    this.workflow = new AcodisWorkflowDTO({
      id: 0,
      name: null,
      importType: null,
      userName: null,
      password: null,
      isInUse: false
    });

    this.router.navigate([acodisWorkflowCreateRoute]);
  }

  public closeWorkflow() {
    this.acodisWorkflowOverviewComponent.resetRowSelected();
    this.workflow = null;
    this.router.navigate([acodisWorkflowRoute]);
    this.acodisWorkflowFormComponent.reset();
    this.acodisWorkflowOverviewComponent.refresh();
  }

  public deleteWorkflow() {
    const dialog = this.modalService.showOkCancelDialog('i18n.domain.import-configuration.acodis-workflows.delete-dialog.title', 'i18n.domain.import-configuration.acodis-workflows.delete-dialog.question');
    dialog.onOkSubject.subscribe(() => {
      this.acodisWorkflowService.deleteRecord(this.workflow.id).subscribe(() => {
        this.closeWorkflow();
      });
    });
  }

  public saveWorkflow() {
    this.acodisWorkflowForm.markAllAsTouched();
    if (this.acodisWorkflowForm.invalid) {
      this.toastService.showWarning('i18n.domain.export-configuration.configurations.messages.form-invalid.title',
        'i18n.domain.export-configuration.configurations.messages.form-invalid.message', null);
      return;
    }
    const workflowValues = this.acodisWorkflowForm.getRawValue() as AcodisWorkflowDTO;
    workflowValues.id = this.workflow.id;
    if (this.workflow.id === 0) {
      this.acodisWorkflowService.addRecord(workflowValues).subscribe((workflow) => {
        this.closeWorkflow();
        this.router.navigate([acodisWorkflowRoute]);
      });
    } else {
      this.acodisWorkflowService.updateRecord(workflowValues).subscribe((workflow) => {
        this.closeWorkflow();
        this.router.navigate([acodisWorkflowRoute]);
      });
    }
  }

  public workflowSelected(workflow: AcodisWorkflowDTO) {
    const id = workflow?.id;
    if (!id) {
      return;
    }

    var workflowId = UrlHelper.getIdForSegment(pages.acodisWorkflowsPageName, this.router);
    if (workflowId == id) {
      //dont redirect, url is already correct
      return;
    }

    this.router.navigate([acodisWorkflowRoute + "/" + id]);
  }

  initForm() {
    this.acodisWorkflowForm = this.fb.group<AcodisWorkflowFormType>({
      name: this.fb.control<string>(null, [Validators.required]),
      importType: this.fb.control<ImportType>(null, [Validators.required]),
      userName: this.fb.control<string>(null, [Validators.required]),
      password: this.fb.control<string>(null, [Validators.required]),
    });
  }

  private loadDataToForm(workflow: AcodisWorkflowDTO) {
    this.acodisWorkflowFormComponent.reset();
    this.acodisWorkflowForm = this.fb.group<AcodisWorkflowFormType>({
      name: this.fb.control<string>(workflow.name, [Validators.required]),
      importType: this.fb.control<ImportType>(workflow.importType, [Validators.required]),
      userName: this.fb.control<string>(workflow.userName, [Validators.required]),
      password: this.fb.control<string>(workflow.password, [Validators.required]),
    });

    if (workflow.isInUse) {
      this.acodisWorkflowForm.controls.importType.disable();
    }
  }
}
